import FormCheckPlate from "./forms/formCheckPlate";

function WorkerComponent(){
    return(
        <div>
            <h1 className="text-center py-3">Panel für Ordnungsbeamte</h1>
        <FormCheckPlate />
        </div>
    )
}

export default WorkerComponent;

